<input
  [matTooltip]="getTooltip()"
  matTooltipPosition="right"
  type="input"
  class="input-box"
  spellcheck="false"
  autocomplete="off"
  (input)="changeValue($event.target)"
/>
